import { FC } from 'react';

import { Grid, } from '@mui/material';

import { IFieldTableHeaderProps } from './types';
import { FieldTableRowTitle } from '../../../FieldTable/components/FieldTableRowTitle';

export const FormTableHeader: FC<IFieldTableHeaderProps> = ({
  columns,
  firstColumnWidth,
  defaultColumns,
  watchColumnTitleName,
  getDefaultColumnTitle,
}) => {

  return (
    <Grid container display="flex" alignItems="center" gap={1}>
      <Grid item sx={{ width: 20 }}>
        {/* column for 3 dots button */}
      </Grid>
      {defaultColumns.map((column) => (
        <Grid key={column} item sx={{ width: firstColumnWidth }}>
        </Grid>
      ))}
      {columns.map((column, index) => (
        <Grid key={column.id} item xs>
          <FieldTableRowTitle
            watchRowTitleName={watchColumnTitleName.replace(':index', String(index))}
            defaultTitle={getDefaultColumnTitle ? getDefaultColumnTitle(index) : 'Untitled'}
          />
        </Grid>
      ))}
    </Grid>
  );
};
